import React, { useEffect, useRef } from 'react';
import './AdBanner.css';

/**
 * AdBanner コンポーネント
 *
 * Google AdSense の広告バナーを表示します。
 * AdSense が有効化されるまではプレースホルダーを表示します。
 *
 * 使用方法:
 * <AdBanner slot="1234567890" format="horizontal" />
 *
 * AdSense 有効化手順:
 * 1. Google AdSense で広告ユニットを作成
 * 2. index.html に AdSense スクリプトを追加
 * 3. VITE_ADSENSE_CLIENT を .env に設定
 * 4. slot に広告ユニットIDを指定
 */

// AdSense クライアントID（環境変数から取得）
const ADSENSE_CLIENT = import.meta.env.VITE_ADSENSE_CLIENT || '';
const ADSENSE_ENABLED = import.meta.env.VITE_ADSENSE_ENABLED === 'true';

function AdBanner({
  slot,
  format = 'auto',
  className = '',
  // 将来的に useSubscription フックで判定
  // isAdFree = false
}) {
  // TODO: ドメイン審査通過後に削除
  return null;

  const adRef = useRef(null);
  const isAdFree = false; // TODO: useSubscription() から取得

  useEffect(() => {
    // 広告非表示ユーザーまたは AdSense 無効時はスキップ
    if (isAdFree || !ADSENSE_ENABLED || !ADSENSE_CLIENT) return;

    try {
      // AdSense の広告をプッシュ
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, [isAdFree]);

  // 広告非表示ユーザーは何も表示しない
  if (isAdFree) return null;

  // AdSense が設定されていない場合はプレースホルダー表示
  if (!ADSENSE_ENABLED || !ADSENSE_CLIENT) {
    return (
      <div className={`ad-placeholder ${className}`}>
        <span className="ad-placeholder-text">広告</span>
      </div>
    );
  }

  return (
    <div className={`ad-container ${className}`}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}

export default AdBanner;
